// File: frontend/src/contexts/SEOContext.js

import React, { createContext, useState, useContext, useCallback } from 'react';

const SEOContext = createContext();

export const SEOProvider = ({ children }) => {
  const [seoData, setSeoData] = useState({
    title: 'Your App',
    description: 'Your application description',
    keywords: 'app, platform, technology',
    canonicalUrl: '',
    ogImage: '',
    ogType: 'website',
    robots: 'index, follow',
    twitterCard: 'summary_large_image',
    language: 'en',
    siteName: 'Your App'
  });

  const updateSEO = useCallback((newSeoData) => {
    setSeoData(prev => ({ ...prev, ...newSeoData }));
  }, []);

  const resetSEO = useCallback(() => {
    setSeoData({
      title: 'Your App',
      description: 'Your application description',
      keywords: 'app, platform, technology',
      canonicalUrl: '',
      ogImage: '',
      ogType: 'website',
      robots: 'index, follow',
      twitterCard: 'summary_large_image',
      language: 'en',
      siteName: 'Your App'
    });
  }, []);

  return (
    <SEOContext.Provider value={{ seoData, updateSEO, resetSEO }}>
      {children}
    </SEOContext.Provider>
  );
};

export const useSEO = () => {
  const context = useContext(SEOContext);
  if (!context) {
    throw new Error('useSEO must be used within a SEOProvider');
  }
  return context;
};
